import styled from 'styled-components';

export const Area = styled.div`
  overflow: hidden;
  opacity: ${(props) => (props.$aberto ? 1 : 0)};
  /* Fechada a area tem altura zero, mas continua sendo item do flex do pai e
     ainda consome o gap dele. O vao negativo devolve esse espaco. */
  margin-bottom: ${(props) =>
    props.$aberto ? '0px' : `calc(-1 * ${props.$vao})`};
  transition:
    max-height 320ms ease,
    opacity 240ms ease,
    margin-bottom 320ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Conteudo = styled.div``;
